export default {
  title: 'Updates',
  fields: {
    app_version: 'App-versie',
    description: 'Beschrijving',
    created_at: 'Aangemaakt op',
  },
};
